import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ToastrService} from "ngx-toastr";
import {IncomeInvoiceApi, UserProfileApi} from "../../../../../../shared/services/sdk/services/custom";
import {AppLoaderService} from "../../../../../../shared/services/app-loader/app-loader.service";

@Component({
  selector: 'app-cancel-invoice',
  templateUrl: './cancel-invoice.component.html',
  styleUrls: ['./cancel-invoice.component.scss']
})
export class CancelInvoiceComponent implements OnInit {

  public invoice_data: any;
    public cancelInvoiceForm: FormGroup;

  constructor(public dialogRef: MatDialogRef<CancelInvoiceComponent>,
              private toastr: ToastrService,
              private fb: FormBuilder,
              private appLoader: AppLoaderService,
              private userProfileApi: UserProfileApi,
              private incomeInvoiceApi: IncomeInvoiceApi,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
      const invoice_data = this.data;

      this.cancelInvoiceForm = this.fb.group({
          id: [invoice_data.id,  Validators.required],
          lease_id: [invoice_data.lease_id,  Validators.required],
          user_id: [this.userProfileApi.getCurrentId(),  Validators.required],
          memo: [null,  Validators.required]
      });
  }


    onNoClick(): void {
        this.dialogRef.close();
    }


    onSubmit() {
        this.appLoader.open('Cancelling invoice...');

        this.incomeInvoiceApi.cancelInvoice(this.cancelInvoiceForm.value).subscribe(
            response => {
                this.appLoader.close();
                this.toastr.success('Invoice successfully cancelled');
                this.dialogRef.close(response.success);
            },
            error => {
                this.appLoader.close();
                this.toastr.error(error.message);
            }
        );
    }

}
